import type { Badge } from './types';
import { Avatar, AvatarImage } from '../../components/ui/avatar';

export const BadgeOptionRenderer = ({ record }: { record: Badge }) => (
  <span className="flex items-center gap-2 p-1">
    <Avatar size="sm">
      <AvatarImage src={record.imageUrl} alt="" />
    </Avatar>
    <span>{record.name}</span>
  </span>
);
